import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';

export default function MobilidadeUrbana() {
  const { watch } = useFormContext();
  
  const mobilidadeSustentavel = watch('mobilidade_sustentavel') === 'sim';
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a mobilidade urbana do município, incluindo transporte público e infraestrutura viária.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="transporte_publico_tipos"
          label="Tipos de transporte público disponíveis"
          placeholder="Digite os tipos de transporte público"
          helpText="Ex: ônibus, metrô, VLT, etc."
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="transporte_publico_extensao"
          label="Extensão da rede de transporte público (km)"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          suffix=" km"
          placeholder="Digite a extensão em km"
          helpText="Extensão total da rede de transporte público em quilômetros"
        />
        
        <FormField
          name="ciclovias_extensao"
          label="Extensão de ciclovias (km)"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          suffix=" km"
          placeholder="Digite a extensão em km"
          helpText="Extensão total de ciclovias e ciclofaixas em quilômetros"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="malha_viaria_condicao"
          label="Condição da malha viária urbana (% em bom estado)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem das vias urbanas em bom estado de conservação"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
        
        <FormField
          name="mobilidade_sustentavel"
          label="Programas de incentivo à mobilidade sustentável"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se o município possui programas de incentivo à mobilidade sustentável"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao6"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao6"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
